// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes placeholderLoader{0%{background-position:-500px 0}to{background-position:500px 0}}.instagram-banner{text-align:center}.instagram-banner__feed{display:flex;justify-content:space-between}.instagram-banner__feed li{width:48%}@media(min-width:768px){.instagram-banner__feed li{width:23%}}.instagram-banner__feed figure{--ratio:1}.instagram-banner__feed img{position:absolute;top:0}.instagram-banner__link{font-size:20px;font-weight:800}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
